import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from "axios";
import { getRequestConfig, onFulfilled, onRejected } from "./resolvers";
import { RequireOne } from "../@typings/typings";
import { JSONAPIDocument } from "json-api-serializer";

export interface HttpClientConfig extends RequireOne<AxiosRequestConfig, "url"> {}

export class HttpClient<T> {
	post: () => Promise<JSONAPIDocument>;

	get: () => Promise<JSONAPIDocument>;

	patch: () => Promise<JSONAPIDocument>;

	delete: () => Promise<JSONAPIDocument>;

	loader: (
		options: AxiosRequestConfig,
		resolve: (response: AxiosResponse<T>) => T,
		reject: (error: AxiosError) => any
	) => Promise<T>;

	constructor(private config: HttpClientConfig) {
		this.loader = (
			requestOptions: AxiosRequestConfig,
			resolve: (response: AxiosResponse<T>) => T,
			reject: (error: AxiosError) => any
		) => {
			return axios.request(requestOptions).then(resolve).catch(reject);
		};

		this.post = () => {
			return this.loader(getRequestConfig({ method: "POST", ...config }), onFulfilled, onRejected);
		};

		this.get = () => {
			return this.loader(getRequestConfig({ method: "GET", ...config }), onFulfilled, onRejected);
		};

		this.patch = () => {
			return this.loader(getRequestConfig({ method: "PATCH", ...config }), onFulfilled, onRejected);
		};

		this.delete = () => {
			return this.loader(getRequestConfig({ method: "DELETE", ...config }), onFulfilled, onRejected);
		};
	}
}
